import { render, staticRenderFns } from "./CardCompassIndustryNew.vue?vue&type=template&id=5543d1fd&scoped=true&"
import script from "./CardCompassIndustryNew.vue?vue&type=script&lang=ts&"
export * from "./CardCompassIndustryNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5543d1fd",
  null
  
)

export default component.exports